// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FlyoutPanel__FlyoutPanelTabList___25ord{cursor:pointer;display:flex;justify-content:center;list-style:none;margin:0 5px 10px 0;padding:0}.FlyoutPanel__TabItemContainer___F2BId{font-size:10px;margin:4px 10px;position:relative;text-align:center;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"FlyoutPanelTabList": "FlyoutPanel__FlyoutPanelTabList___25ord",
	"TabItemContainer": "FlyoutPanel__TabItemContainer___F2BId"
};
module.exports = exports;
